import { createReducer, on } from '@ngrx/store';

import { NavigationActions } from './navigation.actions';
import { initialNavigationState, NavigationState } from './navigation.model';

export const navigationStateReducer = createReducer<NavigationState>(
  initialNavigationState,

  on(
    NavigationActions.openHamburgerMenu,
    (state): NavigationState => ({
      ...state,
      hamburgerMenuOpen: true,
    })
  ),

  on(
    NavigationActions.closeHamburgerMenu,
    (state): NavigationState => ({
      ...state,
      hamburgerMenuOpen: false,
    })
  )
);
